import EvaluatorPaymentItem from '../Domain/EvaluatorPaymentItem';
import objectHelper from '../Helpers/objectHelper';
import serviceHelper from '../Helpers/serviceHelper';
import AuthService from './authService';
import ClientInvoiceEvaluatorPayment from '../Domain/ClientInvoiceEvaluatorPaymentItem';
import SearchParams from '../Elements/SearchParams';
import ClientInvoiceEvaluatorPaymentSearchParams from '../Contents/Operations/ClientInvoiceAdmin/Details/ClientInvoiceEvaluatorPaymentSearchParams';
import AssignmentPaymentsAdminSearchParams from '../Contents/Operations/AssignmentPayments/AssignmentPaymentsAdminSearchParams';

export default class EvaluatorPaymentService {
  static GetEvaluatorPayments(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, AssignmentPaymentsAdminSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/EvaluatorPayments/GetEvaluatorPaymentsByTypeAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetAssignmentPaymentById(id) {
    return AuthService.getInstance().CallBackendFunction(
      `/api/EvaluatorPayments/GetAssignmentPaymentByIdAsync/${id}?clearCache=false`
    );
  }

  static ConvertDBItems(itemlist) {
    const mappedItems = itemlist !== null ? itemlist.map((item) => new EvaluatorPaymentItem(item)) : [];
    return mappedItems;
  }

  static ActionByCommand(command, item) {
    const searchParams = new SearchParams(item.SearchItem, AssignmentPaymentsAdminSearchParams, '', '', 1, 2147483647);

    const idsWithReason = {
      SelectedIds: item.Ids,
      Reason: item.Reason,
      Surcharge: item.Surcharge,
      AllItemsInTheSearchSetAreSelected: item.AllItemsInTheSearchSetAreSelected,
      SearchParams: searchParams.serializeForBackendCall(),
    };
    const url = `/api/EvaluatorPayments/ActionByCommand/${command}`;
    const idsWithReasonJson = JSON.stringify(idsWithReason);

    return AuthService.getInstance().CallBackendFunctionPut(url, idsWithReasonJson);
  }

  static Approve(item) {
    return EvaluatorPaymentService.ActionByCommand('Approve', item);
  }

  static Void(item) {
    return EvaluatorPaymentService.ActionByCommand('Void', item);
  }

  static VoidAndReissue(item) {
    return EvaluatorPaymentService.ActionByCommand('Void and Reissue', item);
  }

  static VoidAndSupress(item) {
    return EvaluatorPaymentService.ActionByCommand('Void and Supress', item);
  }

  static UpsertEvaluatorPayment(item) {
    item = serviceHelper.ConvertAllPropertyToString(item);

    if (item.IeId === '') {
      item.AsId = item.AsSassieAsgnId;
      item.IeRcyid = item.EvaluatorCurrencyId;
      return AuthService.getInstance().CallBackendFunctionPost(
        '/api/EvaluatorPayments/PostPaymentRequestAsync',
        JSON.stringify(item)
      );
    }

    item.AsId = item.IeAsid;
    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/EvaluatorPayments/EditEvaluatorPaymentAsync',
      JSON.stringify(item)
    );
  }

  static GetPaymentRequestStatusNavigation(id) {
    const url = `/api/EvaluatorPayments/GetPaymentRequestStatusNavigationAsync/${id}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static AdvancePaymentRequestWorkflow(actionPayload) {
    const string = objectHelper.toString(actionPayload);
    const json = JSON.stringify(string);
    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/EvaluatorPayments/AdvancePaymentRequestWorkflowAsync/',
      json
    );
  }
  static GetEvaluatorPaymentsByClientInvoice(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = new SearchParams(searchItem, ClientInvoiceEvaluatorPaymentSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    return AuthService.getInstance().CallBackendFunction(
      `/api/EvaluatorPayments/GetEvaluatorPaymentsByClientInvoiceId/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static ConvertDBItemsForClientInvoice(itemlist) {
    let mappedItems = [];

    if (itemlist !== null) {
      mappedItems = itemlist.map((item) => new ClientInvoiceEvaluatorPayment(item));
    }

    return mappedItems;
  }

  static ExportToExcel(searchItem) {
    const searchParams = new SearchParams(searchItem, ClientInvoiceEvaluatorPaymentSearchParams, '', '', 0, 0);
    return AuthService.getInstance().CallBackendFunction(
      `/api/EvaluatorPayments/ExportToExcelAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=false`
    );
  }
}
